function flatDownInfo(arr) {
  return arr.reduce((pre, value) => {
    return Array.isArray(value.child)
      ? [...pre, ...flatDownInfo(value.child)]
      : [...pre, value]
  }, [])
}

function nativeDownloadInfos(data) {
  const { lesson_title, lessong_cover, is_join } = window.baseInfo
  let polyvCourseInfoModels = flatDownInfo(data).filter(
    item => item.duration > 0 || item.flag === '3'
  )
  polyvCourseInfoModels = polyvCourseInfoModels.map(item =>
    Object.assign({}, item, {
      title: encodeURIComponent(item.title)
    })
  )

  let infos = {
    isJoin: is_join,
    courseModel: {
      title: encodeURIComponent(lesson_title),
      img_url: lessong_cover
    },
    polyvCourseInfoModels
  }
  console.log('getCourseDetailInfo', infos)
  return infos
}

export default nativeDownloadInfos



// WEBPACK FOOTER //
// ./src/pages/lesson/detail/components/catalog/nativeDownload.js